// extracted by mini-css-extract-plugin
export var box = "_5q-0";
export var check = "_5q-1";
export var checkboxButton = "_5q-6";
export var checkboxGroup = "_5q-5";
export var disabled = "_5q-7";
export var ghost = "_5q-9";
export var input = "_5q-2";
export var label = "_5q-4";
export var normal = "_5q-8";
export var uncheck = "_5q-3";